import RaceCardsSkeletonImpl from './race-cards-skeleton.js';
import MojitoCore from 'mojito/core';
import PropTypes from 'prop-types';

const { UIView } = MojitoCore.Presentation;

/**
 * Race cards skeleton component used to represent loading race cards.
 *
 * @function RaceCardsSkeleton
 * @memberof Mojito.Modules.RaceCard
 */

/**
 * RaceCardsSkeleton prop types.
 *
 * @property {string} [title] - The title to be rendered.
 *
 * @memberof Mojito.Modules.RaceCard
 */

const propTypes = {
    title: PropTypes.string,
};

export default UIView('RaceCardsSkeleton', RaceCardsSkeletonImpl, propTypes);
